export default function KaretDownIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 6.5L7.62037 9.5571C7.81992 9.78991 8.18008 9.78991 8.37963 9.5571L11 6.5"
        fill="#674759"
      />
      <path
        d="M5 6.5L7.62037 9.5571C7.81992 9.78991 8.18008 9.78991 8.37963 9.5571L11 6.5H5Z"
        stroke="#674759"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
